import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M14.6667 5.68004V2.65337C14.6667 1.71337 14.24 1.33337 13.18 1.33337H10.4867C9.42667 1.33337 9 1.71337 9 2.65337V5.67337C9 6.62004 9.42667 6.99337 10.4867 6.99337H13.18C14.24 7.00004 14.6667 6.62004 14.6667 5.68004Z",
      fill: props.color || '#5528B5'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M14.6667 13.18V10.4867C14.6667 9.42667 14.24 9 13.18 9H10.4867C9.42667 9 9 9.42667 9 10.4867V13.18C9 14.24 9.42667 14.6667 10.4867 14.6667H13.18C14.24 14.6667 14.6667 14.24 14.6667 13.18Z",
      fill: props.color || '#5528B5'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M7.00016 5.68004V2.65337C7.00016 1.71337 6.5735 1.33337 5.5135 1.33337H2.82016C1.76016 1.33337 1.3335 1.71337 1.3335 2.65337V5.67337C1.3335 6.62004 1.76016 6.99337 2.82016 6.99337H5.5135C6.5735 7.00004 7.00016 6.62004 7.00016 5.68004Z",
      fill: props.color || '#5528B5'
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M7.00016 13.18V10.4867C7.00016 9.42667 6.5735 9 5.5135 9H2.82016C1.76016 9 1.3335 9.42667 1.3335 10.4867V13.18C1.3335 14.24 1.76016 14.6667 2.82016 14.6667H5.5135C6.5735 14.6667 7.00016 14.24 7.00016 13.18Z",
      fill: props.color || '#5528B5'
    }, null, 8, _hoisted_5)
  ]))
}
}

})